import { render } from "./ReportGenderDisparityXlsxButton.vue?vue&type=template&id=1d023042"
import script from "./ReportGenderDisparityXlsxButton.vue?vue&type=script&lang=js"
export * from "./ReportGenderDisparityXlsxButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__